import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'out-testimonial',
  imports: [CommonModule],
  templateUrl: './testimonial.component.html',
  styleUrl: './testimonial.component.scss',
})
export class TestimonialComponent {
  testimonials = [
    {
      rating: 5,
      message:
        'Only Used Tesla is a fabulous site. Adam and his team of professionals are super helpful and knowledgeable on all things Tesla, they work hard to help you get to you goals! Highly recommended!',
      name: 'Tony Robbins',
      time: '2 weeks ago',
    },
    {
      rating: 5,
      message:
        'Adam helped me sell my Foundation Cybertruck. He was there to assist all the way through, checking in along the way to be sure all was well. Highly recommend!',
      name: 'Jason Geiger',
      time: '3 weeks ago',
    },
    {
      rating: 5,
      message:
        'Adam is the most helpful and transparent person I’ve ever dealt with when selling or buying a vehicle. You can’t go wrong with using him for either! I know this won’t be the last time I personally deal with him.',
      name: 'Jeremy Nicholson',
      time: '3 weeks ago',
    },
    {
      rating: 5,
      message:
        'Extremely diligent and helpful team.  I was considering selling my Tesla and they worked to get a great price and align logistics.',
      name: 'Sagar Rawal',
      time: 'A month ago',
    },
  ];
}
